import { useState } from 'react';

import { useParams } from 'react-router-dom';

import { DocChronologiesTable } from './components/doc-chronologies-table';
import { HowToCreateDocChronologyDialog } from './components/how-to-create-doc-chronology-dialog';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { useGetSubset } from '@/api/queries/useGetSubset';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { PageTitle } from '@/new/components/page-title';
import { useSubsetBreadcrumbs } from '@/new/hooks/use-subset-breadcrumbs';

export function DocChronologies() {
  const { matterId, subsetId } = useParams();
  if (!matterId || !subsetId) return null;

  const [isHowToCreateDialogOpen, setIsHowToCreateDialogOpen] = useState(false);
  const { data: matter } = useGetMatterV2(matterId);
  const { data: subset } = useGetSubset(matterId, subsetId);

  const breadcrumbItems = useSubsetBreadcrumbs({
    matterId,
    subsetId,
    matter,
    subset,
    currentPage: { label: 'Doc Chronologies', path: 'chronologies/doc' },
  });

  return (
    <>
      <Breadcrumb items={breadcrumbItems} />

      <PageContainer>
        <PageHeader>
          <PageTitle
            text="Doc Chronologies"
            showSubsetChip
            subtext={
              <>
                <p>
                  Build structured timelines of documents. Learn more about{' '}
                  <button
                    type="button"
                    className="inline text-blue-500 hover:text-blue-600"
                    onClick={() => setIsHowToCreateDialogOpen(true)}
                  >
                    how to create a document chronology
                  </button>{' '}
                  in Wexler.
                </p>
                <HowToCreateDocChronologyDialog
                  isOpen={isHowToCreateDialogOpen}
                  onOpenChange={setIsHowToCreateDialogOpen}
                  matterId={matterId}
                  subsetId={subsetId}
                />
              </>
            }
          />
        </PageHeader>
      </PageContainer>

      <DocChronologiesTable />
    </>
  );
}
